import { MapSettingsForm as View } from 'ui-components'
import { DefaultVisualization } from './DefaultVisulization'
import { FieldSettings } from '~map-settings/App/General/FieldSettings'
import { MapName } from '~map-settings/App/General/MapName'
import { PrimaryField } from '~map-settings/App/General/PrimaryField'
import { DeleteMap } from '~map-settings/App/General/DeleteMap'

export const General = () => {
  return (
    <View
      slots={{
        MapName,
        PrimaryField,
        FieldSettings,
        DefaultVisualization,
        DeleteMap
      }}
    />
  )
}
